module.exports = __webpack_public_path__ + "r-v3/img/translation_AR.eaab7fe9.png";